import type { DesktopNotificationSettingsSchema } from '../store/schema';
import { getStore } from '../store/store';

export const getMonarchDesktopNotificationSettings = (): DesktopNotificationSettingsSchema => {
    return getStore().desktopNotificationSettings;
};
